import { Component, OnDestroy, OnInit, Input, ViewChild, } from '@angular/core';

// import { CorporateMembers } from './../api/corporate-members';
import { Trace } from './../../../api/trace';
import { MysqlService } from './../../../services/mysql.service';
import { SearchService,  } from './../../../services/search.service';

import { Meta, Title } from '@angular/platform-browser';
// import {NgxPaginationModule} from 'ngx-pagination'; // <-- import the module not installed // confliced with ngx-miltiselect menu.
// import { AuthService } from '../../../auth/auth.service';

import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
// import { FilterPipe} from './../../../filters/filter.pipe';
import {DemoService} from '../../../demo.service';


import { DatePipe } from '@angular/common';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { catchError, debounceTime, delay, distinctUntilChanged, filter, finalize, merge, of, Subject, switchMap, tap } from 'rxjs';

import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../services/global-functions.service';




import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
// 
import {ReactiveFormsModule, FormControl} from '@angular/forms';
import {Observable, map} from 'rxjs';
// 
// import 'rxjs/add/operator/debounceTime';
// import 'rxjs/add/operator/distinctUntilChanged';
// import 'rxjs/add/operator/switchMap';
// import 'rxjs/add/operator/do';
import { ActivatedRoute, Router } from '@angular/router';


class SearchTrace {
  constructor (
    public trace_id: number,
    public trace_number: string,
    public brand_id: number,
    public client_company_name: string,
    public client_name: string,
    public client_phone: string,
    public special_instructions: any,
    public report_type_id: number,
    public client_client_id: number,
    public updated_by: number,
    public created_date: string,
    public creatded_by: number,
    public created_by: number,
    public owner_trace_code: string,
    public updated_date: number,
      // Advanced Fields // Dev Tools
      public project_type: number,
      public allocated_date: string,
      public allocated_to: number,
      public allocated_by: number,
      public status: number,
      public progress_percentage: number,
      public locate_status: number,
      public total_candidates_count: number,
      public completed_candidates_count: number,
      public completed_date: string,
      public trace_api_key: string,

      // additional fields for statistics and trackings upgrade
public pl_count: number,
public l_count: number,
public nl_count: number,
public fee: number,
public adverage_trace_time: number,
public total_open: number,
public total_all: number,
public total_all_all: number,
public pl_percent: number,
public l_percent: number,
public nl_percent: number,
public completed_by: number,
public start_date: string,
public started_by: number,
public time_taken: number,
) {}
}



class SearchJobSubject {
  constructor (
    public subject_id?: number,
    public job_id?: number,
    public subject_number?: string,
    public first_name?: string,
    public middle_name?: string,
    public surname?: string,
    public title?: string,
    public is_active?: string,
    public next_date?: any,
    public final_date?: any,
    public job_status_id?: number,
    public street_address?: string,
    public suburb?: string,
    public state?: string,
    public  postcode?: string,
    public phone_h?: string,
    public email?: string,
    public dob?: string,
    public phone_m?: string,
    public subject_type_id?: number,
    public file_number?: string,
    public special_instructions?: string,
    public job_status?: string,
    public reference_number?: string,
    public job_reference_number?: string,
    public created_by?: number,
    public created_date?: string,
    public updated_date?: string,
    public updated_by?: number,
    public completed_date?: string,
    public completed_by?: string,
    public start_date?: string,
    public started_by?: string,
    public time_taken?: string,
    public sex?: string,
    public finalised?: string,
    public subject_reference_created?: string,
    public brand_report_user_id?: number,
    public job_type_id?: number,
    public job_type_location_id?: number,
    public job_type_court_id?: number,
    public job_type_document_type_id?: number,
    public job_type_affidavit_type_id?: number,
    public business_name?: string,
    public prev_subject_id?: number,
    public next_subject_id?: number,
    public number_subjects?: number,
    public existing_subjects_count?: number,
    public job_subject_type_id?: number,
    public subject_report_order_number?: number,
    public job_service_rule_id?: number,
    public job_service_timeframe_id?: number,
    public subject_service_type_id?: number,
    public service_company_name?: string,
    public service_directors_name?: string,
    public service_prison_name?: string,
    public service_law_firm_name?: string,
    public service_solicitor_name?: string,
    public owner_trace_code?: string,
    public subject_name?: string,
    public job_number?: string,
    public timeframe_surcharge_id?: number,
    public timeframe_surcharge_colour?: string,
    public timeframe_surcharge_name?: string,
    public timeframe_surcharge_icon?: string,
    public search_match_label?: string,
    public search_match_value?: string,


) {}
}






@Component({
  selector: 'app-job-subject-search-widget',
  templateUrl: './job-subject-search-widget.component.html',
  styleUrls: ['./job-subject-search-widget.component.css']
})
export class JobSubjectSearchWidgetComponent implements OnInit {
 
 // Grid Vars
 public data: DataManager;
 public data_subjects: DataManager;
 public pageSettings: Object;
 public pageOptions = { pageSize: 100 }; 
 public filterOptions: FilterSettingsModel;
 public formatOptions: Object;
 // public filterOptions: FilterSettingsModel;
 public filter : IFilter;
 public toolbarOptions: ToolbarItems[];
 @ViewChild('grid')
 public grid: GridComponent;
 public groupOptions: GroupSettingsModel;
 public templateOptionsDate: IFilterUI;
 public elem1: HTMLElement;
 public datePickerObj: DatePicker;
 subjects_urgent: any;
 formatoptions: { type: string; format: string; };
 dateFormat: string;
 sortOptions: { columns: { field: string; direction: string; }[]; };
 today = new Date();
 initialPage: { pageSize: number; };
 open_jobs_count: any;
  all_router_details: string;

grid_data: any;










  t: Observable<SearchTrace[]>;
  js: Observable<SearchJobSubject[]>;

  loadingT: boolean;
  searchFieldT: FormControl;
  traces: any;

  searchFieldJS: FormControl;
  loadingJS: boolean;

  searchFieldJS_Agent: FormControl;
  searchFieldJS_Client: FormControl;
  // loadingJS: boolean;

loading2: boolean = false;
// search Filter
loading: boolean = false;

searchField: FormControl;
filteredItems: any;
corporatemembersMysql: any;
div: any;
public nav:any;
public body:any;
public container:any;

noPause = true;
// tslint:disable-next-line:no-input-rename
@Input('data') corporatemembers: string[] = [];
page = 1;

// resultsCM: Observable<SearchCorporateMembers[]>;
searchFieldCM: FormControl;

  currentUserVAR: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  sessionUserLevel: any;
  brand_id: any;
  js_results: any;
  searchDisplayLimit = 300;
  searchProbeLimit = 301;
  searchFullLimit = 20002;
  searchHasMoreResults = false;
  searchIsFullMode = false;
  searchReturnedCount = 0;
  private lastSearchTerm = '';
  private searchReload$ = new Subject<void>();


  constructor(
    meta: Meta, title: Title , private _mysqlService: MysqlService,
    public itunes: SearchService, public member: SearchService, public trace: SearchService,
    private _demoService: DemoService,
    private route: ActivatedRoute, private http: HttpClient, private router: Router,
   public gfunc: GlobalFunctionsService
  ) {


              // login vars
 // Set and Access login Session Variables
 this.gfunc.setLoginSessionVars(); // set in a global function file
 this.sessionUserId = this.gfunc.currentUserVAR.user_id;
 this.sessionUsername = this.gfunc.currentUserVAR.username;
 this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

      // need to add this as routes does not work globally
      this.all_router_details = this.router.url;
      this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));


   // Grid Options
   this.toolbarOptions = ['Search'];
   this.initialPage = { pageSize: 40 };
   this.filterOptions = {
      type: 'Menu'
   };

   
  // this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
  this.groupOptions = { }; // sets auto grouping for the grid

   this.formatoptions= {type:'date', format:'dd/MM/yyyy'};
   this.dateFormat = 'dd/MM/yyyy hh:mm a';
   this.filter = { params: { format: this.dateFormat } };
   this.sortOptions = { columns: [{ field: 'job_id', direction: 'Descending' } ] };



   }

  private normaliseSearchTerm(term: any): string {
    if (term === null || term === undefined) {
      return '';
    }
    return term.toString().trim();
  }

  isSearchReady(term: any): boolean {
    return this.normaliseSearchTerm(term).length > 3;
  }

  private createJobSubjectSearchStream(searchField: FormControl, searchRequest: (term: string, limit?: number) => Observable<any>, manageResultLimit: boolean = false): Observable<any> {
    const typedSearchTerms = searchField.valueChanges.pipe(
      debounceTime(400),
      distinctUntilChanged()
    );
    const reloadedSearchTerms = this.searchReload$.pipe(map(() => searchField.value));

    return merge(typedSearchTerms, reloadedSearchTerms).pipe(
      switchMap(term => {
        const searchTerm = this.normaliseSearchTerm(term);
        if (!this.isSearchReady(searchTerm)) {
          this.loadingJS = false;
          this.searchHasMoreResults = false;
          this.searchReturnedCount = 0;
          return of([]);
        }

        if (manageResultLimit && searchTerm !== this.lastSearchTerm) {
          this.searchIsFullMode = false;
        }
        this.lastSearchTerm = searchTerm;

        this.loadingJS = true;
        return searchRequest(searchTerm, manageResultLimit ? this.getSearchRequestLimit() : undefined).pipe(
          map(results => manageResultLimit ? this.prepareSearchResults(results) : results),
          catchError(err => {
            console.error(err);
            this.searchHasMoreResults = false;
            this.searchReturnedCount = 0;
            return of([]);
          }),
          finalize(() => this.loadingJS = false)
        );
      })
    );
  }

  private getSearchRequestLimit(): number {
    return this.searchIsFullMode ? this.searchFullLimit : this.searchProbeLimit;
  }

  private prepareSearchResults(results: any): any[] {
    const searchResults = Array.isArray(results) ? results : [];
    this.searchReturnedCount = searchResults.length;
    this.searchHasMoreResults = !this.searchIsFullMode && searchResults.length > this.searchDisplayLimit;

    if (this.searchHasMoreResults) {
      return searchResults.slice(0, this.searchDisplayLimit);
    }

    return searchResults;
  }

  ngOnInit() {

             // Search Filter
  //  this.searchFieldT = new FormControl();
  //  this.t = this.searchFieldT.valueChanges
  //      .debounceTime(400)
  //      .distinctUntilChanged()
  //       .do(_ => this.loadingT = true)
  //       .filter((val: string) => (val.length > 1)) // only initites if text value exists.
  //       .switchMap(term => this.trace.searchTBrand(term, this.sessionBrandId))
  //      .do(_ => this.loadingT = false);



// Upgraded to work >rjxs 5
  this.searchFieldJS = new FormControl();
  this.js = this.createJobSubjectSearchStream(
    this.searchFieldJS,
    (term, limit) => this.trace.searchJS(term, this.sessionBrandId, limit),
    true
  );


  // this.searchField = new FormControl();
  //   this.results = this.searchField.valueChanges.pipe(
  //     debounceTime(400),
  //     distinctUntilChanged(),
  //     tap(_ => (this.loading = true)),
  //     switchMap(term => this.itunes.search(term)),
  //     tap(_ => (this.loading = false))
  //   );


      // .debounceTime(400)
      // .distinctUntilChanged()
      //  .do(_ => this.loadingJS = true)
      //  .filter((val: string) => (val.length > 3)) // only initites if text value exists.
      //  .switchMap(term => this.trace.searchJS(term, this.sessionBrandId))
      // .do(_ => this.loadingJS = false)
     // console.error(this.cm);
     // need to see if I can filter the searchJS results in a do action. (make a function to keep clean)

     console.log('jsWOKRing: ',   this.js   );
    //  .do(_ => this.filterSearchResults(term => this.trace.searchJS(term, this.sessionBrandId))
    //  );
 


// works the same as "all data grids - jobs and subjects in the system"

// owner // staff
if( this.gfunc.sessionBrandTypeId <= 1) {
            //   this.searchFieldJS_Agent = new FormControl();
            //   this.js = this.searchFieldJS_Agent.valueChanges
            //  .debounceTime(600)
            //  .distinctUntilChanged()
            //   .do(_ => this.loadingJS = true)
            //   .filter((val: string) => (val.length > 2)) // only initites if text value exists.
            //     .switchMap(term => this.trace.searchJS(term, this.gfunc.sessionBrandTypeId)) 
            //     // agent
            //   // .switchMap(term => this.trace.searchJS_Agent(term, null, this.gfunc.sessionBrandTypeId, 'ALLOPEN', this.gfunc.sessionBrandId))
            //  .do(_ => this.loadingJS = false);
}

// agent
if( this.gfunc.sessionUserLevel == 5) {
    //   this.searchFieldJS_Agent = new FormControl();
    //   this.js = this.searchFieldJS_Agent.valueChanges
    //  .debounceTime(600)
    //  .distinctUntilChanged()
    //   .do(_ => this.loadingJS = true)
    //   .filter((val: string) => (val.length > 3)) // only initites if text value exists.
    //     // .switchMap(term => this.trace.searchJS(term, null)) 
    //     // agent
    //   .switchMap(term => this.trace.searchJS_Agent(term, null, this.gfunc.sessionBrandTypeId, 'ALLOPEN', this.gfunc.sessionBrandId))
    //  .do(_ => this.loadingJS = false);


// Upgraded to work >rjxs 5
this.searchFieldJS_Agent = new FormControl();
this.js = this.createJobSubjectSearchStream(
  this.searchFieldJS_Agent,
  term => this.trace.searchJS_Agent(term, null, this.gfunc.sessionBrandTypeId, 'ALLOPEN', this.gfunc.sessionBrandId)
);


}



// client
if( this.gfunc.sessionUserLevel == 9) {
//   this.searchFieldJS_Client = new FormControl();
//   this.js = this.searchFieldJS_Client.valueChanges
//  .debounceTime(600)
//  .distinctUntilChanged()
//   .do(_ => this.loadingJS = true)
//   .filter((val: string) => (val.length > 3)) // only initites if text value exists.
//     // .switchMap(term => this.trace.searchJS(term, null)) 
//     // agent
//   .switchMap(term => this.trace.searchJS_Client(term, null, this.gfunc.sessionBrandTypeId, 'ALLOPEN', this.gfunc.sessionBrandId))
//  .do(_ => this.loadingJS = false);


// Upgraded to work >rjxs 5
this.searchFieldJS_Client = new FormControl();
this.js = this.createJobSubjectSearchStream(
  this.searchFieldJS_Client,
  term => this.trace.searchJS_Client(term, this.gfunc.sessionBrandId, this.gfunc.sessionBrandTypeId, 'ALL', this.gfunc.sessionBrandId)
);


}


};







// Testing did not work.. ended up re-wrting the quiery and new api - above - global - june 2022
filterSearchResults(js){
  if (this.gfunc.sessionUserLevel == 5) {
    let newArr = Object(js).filter((sbi)=>(sbi.brand_type_id == this.gfunc.sessionBrandId)); // User this if filter is needed.
     // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
     this.js = newArr;
    // this.js = DataUtil.parse.parseJson(newArr);
    // this.grid.refresh();
    console.log('this.js: ', this.js);
    
    } else {
// do nothing

      // this.subject_services_data = data;
      // this.brand_types_data = data;
      // this.grid.refresh();
    }
}

getCurrentSearchTerm(): string {
  if (this.gfunc.sessionUserLevel == 5 && this.searchFieldJS_Agent) {
    return this.normaliseSearchTerm(this.searchFieldJS_Agent.value);
  }
  if (this.gfunc.sessionUserLevel == 9 && this.searchFieldJS_Client) {
    return this.normaliseSearchTerm(this.searchFieldJS_Client.value);
  }
  if (this.searchFieldJS) {
    return this.normaliseSearchTerm(this.searchFieldJS.value);
  }
  return '';
}

loadFullSearchResults(): void {
  if (!this.isSearchReady(this.getCurrentSearchTerm())) {
    return;
  }
  this.searchIsFullMode = true;
  this.searchHasMoreResults = false;
  this.searchReload$.next();
}

getSearchOrderSummary(): string {
  return 'Showing top 300 matches, ordered by exact number/name match, active status, then recent updates.';
}

private escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

private escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

highlightSearch(value: any): string {
  const text = this.normaliseSearchTerm(value);
  const escapedText = this.escapeHtml(text);
  const term = this.getCurrentSearchTerm();

  if (!this.isSearchReady(term)) {
    return escapedText;
  }

  const searchPattern = new RegExp('(' + this.escapeRegExp(term) + ')', 'ig');
  return escapedText.replace(searchPattern, '<span class="search-highlight">$1</span>');
}

shouldShowSearchMatchReason(model: any): boolean {
  if (!model || !model.search_match_label || !model.search_match_value) {
    return false;
  }
  return model.search_match_label !== 'Subject name';
}

// Setup the SyncFusion GRID

toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}



jobLink(job_id) {
  // this.router.navigate(['/admin/jobs/create-job-3/' + job_id + '']);
  this.gfunc.globalJobEditStep3(job_id);
}

jobView(job_id) {
  // this.router.navigate(['/admin/jobs/view/' + job_id + '']);
  this.gfunc.globalJobView(job_id);
}

subjectEdit(subject_id){
  // this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
  this.gfunc.globalJobSubjectBillingView(subject_id);
}


refreshGrid(){ // refresh the databutton

  this.grid.refresh();
};


// searchJS(term, limit){
//   this._demoService.searchJS(term, limit).subscribe(
//     data => { 
//      this.js_results = data;
//    },
//     err => console.error(err),
//     // () => console.log('done loading Trace Types')
//   );
// }




};
